
import React from 'react';

import Carousel from "@ingka/carousel";
import CarouselItem from '../UI/CarouselItem';

const FifthSection = (props) => {

    const displayPopupOnClick = () =>{
        console.log("clickImage in  TabPanelItem:::");
        props.onClick();
    }
    
    const categoryHasId = (value) =>{
        return  value.toLowerCase().replace(/\s+/g, "-");
    }

    return (
        <>
            {(props.item.category5[0] && props.item.category5[0].title) && <h3 id={categoryHasId(props.item.category5[0].title)}> {props.item.category5[0].title} </h3>}

            {(props.item.category5[0] && props.item.category5[0].content) &&
                <Carousel>
                    {props.item.category5[0].content.map((carouselItem) => (
                        <CarouselItem
                            className={carouselItem.className}
                            key={carouselItem.id}
                            image={carouselItem.imagePath}
                            NameofDish={carouselItem.NameofDish}
                            title={carouselItem.title}
                            onClick = {displayPopupOnClick}
                        />
                    ))}
                </Carousel>
            }
        </>
    )
}

export default FifthSection;
